/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';

const SystemConfigurationGeneralRedirect = (): React.JSX.Element => (
	<ScreenRedirect to="/jira/settings/system/general-configuration" />
);

export default SystemConfigurationGeneralRedirect;
